<template>
  <Head :title="form.equipament.name" />
  <div class="p-4 min-h-screen flex justify-center light">
    <div class="w-full lg:w-1/2">
      <flash-messages />
      <logo class="block mx-auto w-32 h-auto py-2" />
      <form class="bg-white dark:bg-slate-900 border border-gray-100 rounded-lg shadow-xl overflow-hidden" @submit.prevent="store">
        <div class="px-6 py-6">
          <h2 class="text-center font-bold text-lg">{{form.equipament.name}}</h2>
          <div class="mx-auto mt-2 mb-4 w-24 border-b" />

          <div v-if="classifications.length" class="w-full">
            <div v-if="selectedClassification" class="flex items-center gap-3 mb-4">
              <button type="button" class="text-xs text-indigo-600 hover:underline whitespace-nowrap" @click="resetClassification">
                ← Volver
              </button>
              <div class="flex items-center gap-2 bg-indigo-50 border border-indigo-500 rounded-lg px-4 py-2">
                <icon v-if="selectedClassification.icon" :name="selectedClassification.icon" class="w-6 h-6 fill-indigo-600" />
                <span class="font-semibold text-sm text-indigo-700">{{ selectedClassification.name }}</span>
              </div>
            </div>

            <label class="form-label">{{ selectedClassification ? 'Selecciona el detalle' : '¿Qué deseas reportar?' }}</label>

            <transition name="slide-swap" mode="out-in">
              <div v-if="!selectedClassification" key="classifications" class="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">
                <button
                  v-for="c in classifications"
                  :key="c.id"
                  type="button"
                  class="flex flex-col items-center justify-center p-4 rounded-lg border-2 gap-2 border-gray-200"
                  @click="selectClassification(c)"
                >
                  <icon v-if="c.icon" :name="c.icon" class="w-8 h-8 fill-gray-600" />
                  <span class="text-sm text-center">{{ c.name }}</span>
                </button>
              </div>

              <div v-else key="subclassifications" class="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">
                <button
                  v-for="s in filteredSubclassifications"
                  :key="s.id"
                  type="button"
                  class="flex flex-col items-center justify-center p-4 rounded-lg border-2 gap-2"
                  :class="form.subclassification_id === s.id ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200'"
                  @click="form.subclassification_id = s.id"
                >
                  <icon v-if="s.icon" :name="s.icon" class="w-8 h-8 fill-gray-600" />
                  <span class="text-sm text-center">{{ s.name }}</span>
                </button>
                <p v-if="filteredSubclassifications.length === 0" class="col-span-full text-sm text-gray-400">No hay subcategorías configuradas para esta clasificación, puedes continuar.</p>
              </div>
            </transition>
            <div v-if="form.errors.classification_id" class="form-error">{{ form.errors.classification_id }}</div>
          </div>

          <div class="w-full mt-6">
            <textarea-input v-model="form.details" :rows="4" :label="__('Request Details') + ':'" class="w-full" />
          </div>

          <div class="w-full mt-3">
            <input ref="fileInput" type="file" multiple class="hidden" @change="onFilesSelected" />
            <button type="button" class="flex items-center gap-2 text-sm text-indigo-600 hover:underline" @click="$refs.fileInput.click()">
              <icon name="camera" class="w-5 h-5 fill-indigo-600" />
              Tomar foto o adjuntar archivo
            </button>
            <div v-if="form.files.length" class="flex flex-wrap gap-2 mt-3">
              <div v-for="(file, index) in form.files" :key="index" class="flex items-center gap-2 bg-gray-100 rounded px-3 py-2 text-xs">
                <span class="max-w-[140px] truncate">{{ file.name }}</span>
                <button type="button" class="text-red-600" @click="removeFile(index)">✕</button>
              </div>
            </div>
          </div>

          <loading-button :loading="form.processing" class="ml-auto btn-indigo w-full items-center justify-center mt-6" type="submit">{{ __('Create') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import { Head, Link } from '@inertiajs/inertia-vue3'
import FlashMessages from '@/Shared/FlashMessages'


export default {
  metaInfo: { title: 'Login' },
  components: {
      FlashMessages,
    LoadingButton,
    Logo,
    Icon,
    TextareaInput,
      Head,
      Link,
  },
    props: {
        is_demo: Number,
        equipament : Object,
        classifications : Array,
        subclassifications : Array,
    },
  data() {
    return {
      form: this.$inertia.form({
        details : '',
        classification_id : null,
        subclassification_id : null,
        equipament : this.equipament,
        files : [],
        remember: false,
      }),
    }
  },
  computed: {
    selectedClassification() {
      return this.classifications.find(c => c.id === this.form.classification_id) || null
    },
    filteredSubclassifications() {
      if (!this.form.classification_id) return []
      return this.subclassifications.filter(s => s.classification_id === this.form.classification_id)
    },
  },
  methods: {
     selectClassification(c) {
        this.form.classification_id = c.id
        this.form.subclassification_id = null
     },
     resetClassification() {
        this.form.classification_id = null
        this.form.subclassification_id = null
     },
     onFilesSelected(e) {
        this.form.files = [...this.form.files, ...Array.from(e.target.files)]
        e.target.value = null
     },
     removeFile(index) {
        this.form.files.splice(index, 1)
     },
     store() {
        this.form.post(this.route('qr.create.ticket.save'))
     },
  }
}
</script>

<style scoped>
.slide-swap-enter-active,
.slide-swap-leave-active {
  transition: all 0.25s ease;
}
.slide-swap-enter-from {
  opacity: 0;
  transform: translateY(-14px);
}
.slide-swap-leave-to {
  opacity: 0;
  transform: translateY(14px);
}
</style>
